import React from "react";
import { NavLink } from "react-router-dom";
import { Box } from "@mui/material";

import {
  SidebarDrawerMenu as SidebarDrawerMenuTelluriaUi,
  SidebarDrawerMenuProps as SidebarDrawerMenuPropsTelluriaUi
} from "@npm-telluria-tecnologia/telluria-ui";

export interface SidebarDrawerMenuProps
  extends SidebarDrawerMenuPropsTelluriaUi {
  link: string;
  /** Pill shown after the label ("Novo" on Documentação while a new version is unseen) */
  badge?: string;
}

const badgeSx = {
  position: "absolute",
  top: "50%",
  right: 24,
  transform: "translateY(-50%)",
  backgroundColor: "#ffcc00",
  color: "#002951",
  fontSize: "0.72rem",
  fontWeight: 700,
  lineHeight: 1.5,
  padding: "1px 8px",
  borderRadius: "10px",
  pointerEvents: "none"
};

const SidebarDrawerMenu: React.FC<SidebarDrawerMenuProps> = ({
  id,
  title,
  icon,
  identifierColor,
  secondaryColor,
  link,
  type,
  onClick,
  badge
}) => (
  <NavLink to={link}>
    <Box sx={{ position: "relative" }}>
      <SidebarDrawerMenuTelluriaUi
        id={id}
        title={title}
        icon={icon}
        identifierColor={identifierColor}
        secondaryColor={secondaryColor}
        type={type}
        onClick={onClick}
      />
      {badge && <Box component="span" sx={badgeSx}>{badge}</Box>}
    </Box>
  </NavLink>
);

SidebarDrawerMenu.defaultProps = {
  badge: undefined
};

export default SidebarDrawerMenu;
